export const WATCHLIST_LOAN_DETAIL_MODAL = 'WATCHLIST_LOAN_DETAIL_MODAL';
export const WATCHLIST_ADD_LOAN_MODAL = 'WATCHLIST_ADD_LOAN_MODAL';
export const GROUP_ITEMS_MODAL = 'GROUP_ITEMS_MODAL';

export const setWatchlistLoanDetailModal = (state) => (dispatch) => {
    dispatch({ type: WATCHLIST_LOAN_DETAIL_MODAL, state });
};

export const setWatchlistAddLoanModal = (state) => (dispatch) => {
    dispatch({ type: WATCHLIST_ADD_LOAN_MODAL, state });
};

export const setGroupItemsModal = (state) => (dispatch) => {
    dispatch({ type: GROUP_ITEMS_MODAL, state });
};

export default {
    WATCHLIST_LOAN_DETAIL_MODAL,
    WATCHLIST_ADD_LOAN_MODAL,
    GROUP_ITEMS_MODAL,
    setWatchlistLoanDetailModal,
    setWatchlistAddLoanModal,
    setGroupItemsModal,
};
